import { getInfo, logout as logoutApi } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
    userInfo: null,
    token: getToken() || '',
    settleStatus: null
}

const getters = {
    userInfo: state => state.userInfo,
    token: state => state.token,
    settleStatus: state => state.settleStatus
}

const mutations = {
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo
    },
    SET_TOKEN(state, token) {
        state.token = token
    },
    SET_SETTLE_STATUS(state, status) {
        state.settleStatus = status
    },
    CLEAR_USER_INFO(state) {
        state.userInfo = null
        state.token = ''
        state.settleStatus = null
    }
}

const actions = {
    // 获取用户信息    
    async getUserInfo({ commit }) {
        try {
            const res = await getInfo()
            if (res.code === 200 && res.data) {
                const data = res.data
                commit('SET_USER_INFO', data)
                return data
            }
            return null
        } catch (error) {
            console.error('获取用户信息失败:', error)
            return null
        }
    },

    // 设置用户信息
    setUserInfo({ commit }, userInfo) {
        commit('SET_USER_INFO', userInfo)
    },

    // 设置 token
    setToken({ commit }, token) {
        commit('SET_TOKEN', token)
        setToken(token)
    },

    // 登出
    async logout({ commit }) {
        try {
            // 调用后端退出登录接口
            await logoutApi()
        } catch (error) {
            console.error('退出登录失败:', error)
        } finally {
            // 无论后端请求成功与否，都清除本地数据
            commit('CLEAR_USER_INFO')
            removeToken()
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
